import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-new-customer-regitration',
  templateUrl: './track-new-customer-regitration.component.html',
  styleUrls: ['./track-new-customer-regitration.component.css']
})
export class TrackNewCustomerRegitrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
